<template>
  <div class="panel-body">
    <template>
      <v-card width="1000px">
      <v-data-table
        v-model="historyModel"
        :headers="headers"
        :items="history"
        item-key="id"
        class="elevation-1"
        :rows-per-page="rowsPerPage"
        :items-per-page-options="rppItems"
      >
      <template slot="item" slot-scope="props">
        <tr>
          <td class="text-xs-center" width="500px">{{ props.item.category }}</td>
          <td class="text-xs-center" width="500px">{{ formatDate(props.item.date) }}</td>
          <td class="text-xs-center" width="500px">{{ formatDate(props.item.transactionDate) }}</td>
          <td class="text-xs-center" width="500px">${{ props.item.amount.toFixed(2) }}</td>
          <td class="text-xs-center" width="500px">{{ props.item.transferStatus }}</td>
          </tr>
      </template>
      <template slot="no-data">
      </template>
    </v-data-table>
    </v-card>
    </template>
  </div>

</template>

<script>
import moment from 'moment'
let rh = require('@/components/APIs/RequestHandler')

export default {
  props: {
    jarId: {
      type: Number,
      required: true
    },
    userId: {
      type: Number,
      required: true
    }

  },
  data: () => ({
    loadingHistory: false,
    rppItems: [
      10,
      50,
      100,
      { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }
    ],
    rowsPerPage: 10,
    historyModel: [],
    errors: [],
    headers: [
      { text: 'Category', align: 'left', sortable: false, value: 'category' },
      { text: 'Date', align: 'center', sortable: false, value: 'date' },
      { text: 'Transaction Date', align: 'center', value: 'transactionDate' },
      { text: 'Amount', align: 'center', value: 'amount' },
      { text: 'Transfer Status', value: 'transferStatus' }
    ],
    history: []
  }),
  created () {
    this.loadHistory()
  },
  mounted () {
    this.loadHistory()
  },
  watch: {
    jarId: {
      immediate: true,
      deep: true,
      handler (newValue, oldValue) {
        this.loadHistory()
      }
    }
  },

  methods: {

    async loadHistory () {
      if (this.userId == null || this.userId === '' || this.jarId == null || this.jarId === '') {
        // console.log('User ID or Jar ID not set, unable to load jar history')
        this.history = []
        return
      }
      // this.loadingHistory = true
      var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_ACCOUNT}/owners/${this.userId}/accounts/jar-${this.jarId}/transactions`

      var getResponse = await rh.default.get(endpoint, true).catch(e => {
        this.errors.push(e)
      })
      if (getResponse === undefined) { this.history = [] } else { this.history = getResponse.data }
      // this.loadingHistory = false
    },

    formatDate (aDate) {
      return moment(String(aDate)).format('MM/DD/YYYY hh:mm:ss')
    }
  }
}
</script>
<style>
</style>
